import React from 'react';
import request from '../../utils/agent';

const timeOpts = [
    {id: "", display: 'Set Hour'},
    {id: "0", display: '12:00 AM'},
    {id: "1", display: '1:00 AM'},
    {id: "2", display: '2:00 AM'},
    {id: "3", display: '3:00 AM'},
    {id: "4", display: '4:00 AM'},
    {id: "5", display: '5:00 AM'},
    {id: "6", display: '6:00 AM'},
    {id: "7", display: '7:00 AM'},
    {id: "8", display: '8:00 AM'},
    {id: "9", display: '9:00 AM'},
    {id: "10", display: '10:00 AM'},
    {id: "11", display: '11:00 AM'},
    {id: "12", display: '12:00 PM'},
    {id: "13", display: '1:00 PM'},
    {id: "14", display: '2:00 PM'},
    {id: "15", display: '3:00 PM'},
    {id: "16", display: '4:00 PM'},
    {id: "17", display: '5:00 PM'},
    {id: "18", display: '6:00 PM'},
    {id: "19", display: '7:00 PM'},
    {id: "20", display: '8:00 PM'},
    {id: "21", display: '9:00 PM'},
    {id: "22", display: '10:00 PM'},
    {id: "23", display: '11:00 PM'},
];

const dayMap = [
    {"Mon": ["from", "to", "closed"]},
    {"Tues": ["from", "to", "closed"]},
    {"Weds": ["from", "to", "closed"]},
    {"Thurs": ["from", "to", "closed"]},
    {"Fri": ["from", "to", "closed"]},
    {"Sat": ["from", "to", "closed"]},
    {"Sun": ["from", "to", "closed"]}
]

export default class AdminNewCsm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            csm: {
                email: '',
                first_name: '',
                last_name: '',
                phone: '',
                hoursofoperation: {
                    Mon: {
                        from: "",
                        to: "",
                        closed: false
                    },
                    Tues: {
                        from: "",
                        to: "",
                        closed: false
                    },
                    Weds: {
                        from: "",
                        to: "",
                        closed: false
                    },
                    Thurs: {
                        from: "",
                        to: "",
                        closed: false
                    },
                    Fri: {
                        from: "",
                        to: "",
                        closed: false
                    },
                    Sat: {
                        from: "",
                        to: "",
                        closed: false
                    },
                    Sun: {
                        from: "",
                        to: "",
                        closed: false
                    }
                }
            }
        };
    }

    saveCSM = () => {
        let payload = {...this.state.csm};

        request.post(`/api/csm`)
            .send(payload)
            .then(resp => {
                // Do nothing?
                window.location.href = '/admin/csms';
            })
            .catch(err => {
                console.error('error', err);
                try {
                    alert(err.response.body[0].message);
                } catch(e) {}
            });
    }

    handleChange = (e) => {
        let csm = {...this.state.csm};
        let upd = csm;
        let path = e.target.name.split('.');
        while(path.length > 1) {
            upd = upd[path.shift()];
        }
        if(e.target.type === 'checkbox') {
            upd[path] = e.target.value === "on" ? true : false;
        } else {
            upd[path] = e.target.value;
        }
        this.setState({csm});
    }

  render() {
    return (
        <section className='profile--container'>
            <h1>CSM</h1>
            <div className='profile-data'>
                <div className='short-desc'>
                    <h3>Create CSM</h3>
                </div>
                <div className='profile-details'>
                    <div className="my-f-form">
                        <label className="form-f-label">Email*</label>
                        <input name="email" className="form-f-field" type="text" placeholder="Email*" onChange={this.handleChange} value={this.state.csm.email} />
                        <label className="form-f-label">Phone*</label>
                        <input name="phone" className="form-f-field" type="phone" placeholder="Phone*" onChange={this.handleChange} value={this.state.csm.phone} />
                        <div className="flex--fields--holder">
                            <div className="flex-field-container">
                                <label className="form-f-label">First Name*</label>
                                <input name="first_name" className="form-f-field" type="text" placeholder="First Name*" onChange={this.handleChange} value={this.state.csm.first_name} />
                            </div>
                            <div className="flex-field-container last">
                                <label className="form-f-label">Last Name*</label>
                                <input name="last_name" className="form-f-field" type="text" placeholder="Last Name*" onChange={this.handleChange} value={this.state.csm.last_name} />
                            </div>
                        </div>
                        <label className='form-f-label'>Hours of Operation</label>
                        <div className='op-hours-container'>
                            <div className='time-opts-table'>
                                {dayMap.map((day, i) => {
                                    let dayName = Object.keys(day)[0];
                                    let values = Object.values(day)[0];
                                    let inputNames = values.slice(0,2);
                                    let inputClosed = values.slice(2);
                                    return (
                                        <div className='time-opt-row' key={`${day}-${i}`}>
                                            <div className='titles-container'>
                                                <div className='text-title'>{dayName}</div>
                                            </div>
                                            <div className='time-selects-holder'>
                                                {inputNames.map(name => {
                                                    return (
                                                        <select key={`${dayName}-${name}`}
                                                            name={`hoursofoperation.${dayName}.${name}`}
                                                            className='open-time-selector'
                                                            onChange={this.handleChange} 
                                                            defaultValue={this.state.csm.hoursofoperation[dayName][name]}
                                                            >
                                                            {timeOpts.map(option => (
                                                                <option key={`${dayName}-${name}-${option.id}`}
                                                                        value={option.id}>
                                                                    {option.display}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    )
                                                })}
                                            </div>
                                            <div className='check-boxes-holder'>
                                                <input className='closed--checkbox' type='checkbox'
                                                    onChange={this.handleChange} 
                                                    name={`hoursofoperation.${dayName}.${inputClosed}`} defaultChecked={this.state.csm.hoursofoperation[dayName][inputClosed]}>
                                                </input>
                                            </div>
                                            <div className='titles-container'>
                                                <div className='text-title'>Closed</div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                    <br/>
                    <button className="btn btn-default btn-primary" onClick={this.saveCSM}>Save CSM</button>
                </div>
            </div>
        </section>
    )
  }
}


// WEBPACK FOOTER //
// ./src/routes/AdminNewCsm/index.js